import { render, staticRenderFns } from "./teacherControlPanel.vue?vue&type=template&id=6c821f5e&scoped=true"
import script from "./teacherControlPanel.vue?vue&type=script&lang=js"
export * from "./teacherControlPanel.vue?vue&type=script&lang=js"
import style0 from "./teacherControlPanel.vue?vue&type=style&index=0&id=6c821f5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c821f5e",
  null
  
)

export default component.exports